// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QvuDB","top":"styles_top__3Mhxo","left":"styles_left__21p1w","description":"styles_description__3zf-s"};